{
  "error.generic": "Der skete en fejl",
  "error.validation": "Valideringsfejl",
  "error.noLoanInfo": "Aftaledata findes ikke",
  "error.companyNumberMissing": "Kundenummer mangler",
  "error.noCompanyFound": "Kundedata findes ikke",
  "error.noAccess": "Du har ikke adgang til portalen",
  "error.component.title": "Komponent på siden fejler",
  "error.component.message": "Kontakt Projekt Låneportal ved Jesper Bruun (JBR) eller Mathias Marcussen (MMA) og oplys følgende; fejltype, fejltidspunkt, udløsende handling og forventet resultat.",
  "error.api.title": "API fejl på siden",
  "error.api.message": "Kontakt Projekt Låneportal ved Jesper Bruun (JBR) eller Mathias Marcussen (MMA) og oplys følgende; fejltype, fejltidspunkt, udløsende handling og forventet resultat",
  "app.title": "Kundeportal",
  "app.kk": "KommuneKredit",
  "closeMenu": "Luk",
  "openMenu": "Åbn",
  "delete": "slet",
  "edit": "rediger",
  "update": "Opdater",
  "export": "Eksporter",
  "complete": "Gennemfør",
  "payment_one": "betaling",
  "payment_other": "betalinger",
  "contact": "Kontakt",
  "contactInfo": "Kontaktoplysninger",
  "email": "E-mail",
  "phone": "Telefon",
  "name": "Navn",
  "address": "Adresse",
  "undefined": "Udefineret",
  "role_one": "rolle",
  "role_other": "roller",
  "roles.Access": "Adgang",
  "roles.AuthorizedToSign": "Tegningsberettiget",
  "name.unknown": "Ukendt $t(name)",
  "email.unknown": "Ukendt $t(email)",
  "calculation_one": "beregning",
  "calculation_other": "beregninger",
  "calculation_specific": "beregningen",
  "calculation_specific_other": "beregningerne",
  "calculation": "beregningerne",
  "loan_one": "Aftale",
  "loan_specific": "Aftalen",
  "loan_other": "Aftaler",
  "loan.number": "Aftale nr.",
  "loan_specific_other": "Aftalerne",
  "year_one": "år",
  "year_other": "år",
  "company_one": "kunde",
  "company_specific": "kunden",
  "currency": "Valuta",
  "company_other": "kunder",
  "company_specific_other": "kunderne",
  "case_one": "sag",
  "phoneHours": "Telefontider",
  "case_specific": "sagen",
  "case_other": "sager",
  "case_specific_other": "sagerne",
  "swap_one": "swap",
  "swap_other": "swaps",
  "rateFrequency": "rentefrekvens",
  "rateFrequency.M1": "Månedlig",
  "rateFrequency.M2": "$t(unavailable)",
  "rateFrequency.M3": "Kvartårlig",
  "rateFrequency.M4": "$t(unavailable)",
  "rateFrequency.M6": "Halvårlig",
  "rateFrequency.M12": "Årlig",
  "loanPeriod": "løbetid",
  "loanPeriod_specific": "løbetiden",
  "loanPurpose": "Låneformål",
  "loanProduct": "produkttype",
  "loanProduct.KKfast": "KKfast",
  "loanProduct.KKfast.description": "Renten er den samme i lånets løbetid, og renteudgiften ligger derfor fast i hele perioden.",
  "loanProduct.KKvar": "KKvar",
  "loanProduct.KKvar.description": "Renten er variabel. KommuneKredit fastsætter løbende renten i forhold til, hvordan renten i markedet udvikler sig.",
  "loanProduct.KKcibor": "KKcibor",
  "loanProduct.KKcibor.description": "Renten er variabel og består af den danske referencerente, CIBOR, samt et fast tillæg eller fradrag.",
  "loanProduct.Byggekredit": "Byggekredit",
  "loanProduct.Byggekredit.description": "Renten er variabel, og I betaler kun rente af det beløb, I har trukket. Byggekreditten kan kun bruges til bygge- eller anlægsprojekter og skal indfries eller omlægges til lån, når byggeriet er færdigt.",
  "fixedInterestPeriod": "Rentebinding",
  "fixedInterestPeriod.cibor": "Rentebinding (KK tillæg)",
  "fixedInterestPeriod.Cheapest": "Billigste renteaftale",
  "fixedInterestPeriod.ToMaturity": "Hele løbetiden",
  "fixedInterestPeriod.Years": "Årlig",
  "fixedInterestPeriod.UnDefined": "$t(unavailable)",
  "constructionCredit": "Byggekredit",
  "lastUpdated": "Senest opdateret",
  "calculate.financing": "Beregn finansiering",
  "loan.loanInformation": "Aftaleoplysninger",
  "loan.priceInformation": "Prisoplysninger",
  "loan.currentRate": "Aktuel rentesats",
  "loan.currentRate.tooltip": "Inkl. KK tillæg",
  "loan.initialCosts": "Etableringsomkostninger",
  "loan.latestRateSetting.notAvailable": "Fastsat dato ikke tilgængelig",
  "loan.spread.cibor": "- Heraf KK tillæg",
  "loan.customerSwap": "Renteswap",
  "loan.nonAccruedInterest.credit": "Ikke tilskrevne renter pr. dd.",
  "loan.liability.description": "Her kan I se en liste over de kommuner/regioner, der stiller garanti for denne aftale og hvor meget de garanterer for.",
  "rateFrequency.UnDefined": "$t(unavailable)",
  "amortizationProfile": "afdragsprofil",
  "amortizationProfile.Bullet": "Stående",
  "amortizationProfile.Annuity": "Annuitetslån",
  "amortizationProfile.Annuity.description": "Ydelsen er den samme hver termin. I starten betaler I mest i rente. Senere falder renterne, og afdraget stiger.",
  "amortizationProfile.Serial": "Serielån",
  "amortizationProfile.Serial.description": "Ydelsen falder i løbet af lånets løbetid. Afdraget er det samme hver termin, mens renteudgiften falder over tid.",
  "amortizationProfile.Standing": "Stående lån",
  "amortizationProfile.Custom": "$t(unavailable)",
  "amortizationProfile.UnDefined": "$t(unavailable)",
  "table.date.label": "Skæringsdato",
  "table.date.latestBankDay": "Seneste bankdag",
  "table.edit": "Indstil tabel",
  "table.hideColumn": "Skjul kolonne",
  "table.fullscreen": "Fuld skærm",
  "table.close": "Luk fuld skærm",
  "table.filterLoanType": "Produkttype",
  "table.filterDate": "Skæringsdato",
  "table.setFilterDate": "Vælg skæringsdato",
  "table.setupDescription": "Du kan ændre rækkefølgen af kolonner ved at trække i felterne nedenunder.",
  "table.addProjectName": "Tilføj projektnavn",
  "table.editProjectName": "Rediger projektnavn",
  "table.projectNameModalDescription": "Projektnavn vil slå igennem på tværs af din organisation",
  "table.saveSettings": "Gem indstillinger",
  "table.clearFilters": "Ryd filtre",
  "table.sort.asc": "Sorter stigende",
  "table.sort.desc": "Sorter faldende",
  "table.sort.none": "Ryd sortering",
  "table.filter.clear": "Ryd filtre",
  "table.filter.showResults_one": "Vis {{ count }} resultat",
  "table.filter.showResults_other": "Vis {{ count }} resultater",
  "engagementWidget.title": "Samlet engagement pr. {{ date, date }}",
  "engagementWidget.description": "Her kan I se en samlet oversigt over jeres låneaftaler, opgjort i danske kroner (DKK).\nHar I låneaftaler i udenlandsk valuta, er de omregnet til DKK.",
  "engagementWidget.link": "Se jeres aftaler",
  "engagementWidget.remainingDebt": "Restgæld ustøttede låneaftaler",
  "engagementWidget.remainingDebtSupported": "Restgæld støttede låneaftaler",
  "engagementWidget.remainingDebtCombined": "Restgæld låneaftaler",
  "engagementWidget.loanCount": "Antal låneaftaler",
  "engagementWidget.creditCount": "Antal kreditaftaler",
  "promo.guarantor.title": "Engagement som garantistiller",
  "promo.guarantor.description": "Her kan I få et overblik over de aftaler, som I stiller garanti for.",
  "promo.guarantor.link": "Se aftaler som garantistiller",
  "promo.budgetModel.title": "Budgetmodel",
  "promo.budgetModel.description": "I budgetmodellen kan I indtaste en forventet rentesats for en 5-årig periode og se, hvordan den indtastede rente påvirker jeres portefølje.",
  "promo.budgetModel.link.subsidized": "Hent budgetmodel (støttede lån)",
  "promo.budgetModel.link.nonSubsidized": "Hent budgetmodel",
  "promo.calculator.title": "Låneberegner",
  "promo.calculator.description": "Med få klik kan I lave en her-og-nu-beregning af, hvad det koster at låne.\n\nSamtidig får I en oversigt over lånets ydelser gennem hele lånets løbetid.",
  "promo.calculator.link": "Gå til låneberegner",
  "currentRate.widget.title": "Aktuel rentesats",
  "currentRate.widget.description": "Her kan du se den aktuelle rentesats for en byggekredit. Renten er vejledende og kan ændre sig fra dag til dag.",
  "messages.title": "Beskeder",
  "messages.link": "Se alle beskeder",
  "messages.action": "Se alle beskeder",
  "message.readyForSigning": "klar til underskrift",
  "message.description": "Underskriv {{ documentName }} senest d. {{ deadline, date }}",
  "contractOverview.title": "Aftaler",
  "contractOverview.Owner.title": "Vores aftaler",
  "contractOverview.Owner.info": "Det er muligt at se detaljer for aftaler af typerne {{ loanTypes }}",
  "contractOverview.Guarantee.title": "Aftaler som garantstiller",
  "contractOverview.PartnershipLiability.title": "Aftaler som interessent",
  "contractOverview.selectContractType": "Vælg produkttype",
  "contractOverview.period": "Periode",
  "engagementOverview.applyForLoan-label": "Ansøg nyt lån",
  "engagementOverview.loanTab.keyNumbers.title": "Nøgletal",
  "engagementOverview.loanTab.keyNumbers.description": "Samlede portefølje, ekskl. støttede lån og garantiån pr. dags dato",
  "engagementOverview.loanTab.keyNumbers.total.debt.label": "Samlet restgæld",
  "engagementOverview.loanTab.keyNumbers.average.amount.label": "Gennemsnitlig lånesum",
  "engagementOverview.loanTab.keyNumbers.number.of.loans.label": "Antal lån",
  "engagementOverview.loanTab.keyNumbers.construction.loans.label": "Antal byggekreditter",
  "engagementOverview.loanTab.keyNumbers.number.of.loans.link": "Se låneoversigt",
  "engagementOverview.loanTab.keyNumbers.construction.loans.link": "Se byggekreditter",
  "engagementOverview.loanTab.distribution.title": "Fordeling",
  "engagementOverview.loanTab.distribution.description": "Se jeres samlede restgæld fordelt på låntyper pr dags dato.",
  "engagementOverview.loanTab.loanOverview.title": "Aftaler",
  "engagementOverview.loanTab.loanOverview.description": "Denne oversigt viser kun aftalelån, eksl. støttede lån og garantilån.",
  "calculatorPage.title": "Låneberegner",
  "calculatorPage.results.title": "Beregningsresultater",
  "calculatorPage.description": "Med få klik kan du lave en her-og-nu-beregning af, hvad det koster at låne hos os. Du får en oversigt over ydelser, renteomkostninger og udviklingen i restgælden gennem hele lånets løbetid.",
  "calculatorPage.button.export": "Eksportér beregninger",
  "calculatorPage.export.excel": "Eksporter til Excel",
  "calculatorPage.export.pdf": "Eksporter til PDF",
  "calculatorPage.compare": "Sammenlign beregninger",
  "calculatorPage.export": "Eksportér beregninger",
  "calculatorPage.export.selectCalculations": "Vælg de aftaler, der skal inkluderes i eksport..",
  "calculatorPage.compare.selectCalculations": "Vælg de aftaler, der skal sammenlignes.",
  "calculatorPage.result.createdDate": "Beregning udført d. {{ date }} ",
  "calculatorPage.message.leave.title": "Er du sikker på, at du vil forlade låneberegneren?",
  "calculatorPage.message.leave.description": "Hvis du forlader låneberegneren, mister du dine indtastninger og udførte beregninger.",
  "calculationComparison.hide": "Skjul beregning",
  "calculationComparison.viewDetails": "Se detaljer",
  "calculatorForm.principalAmount.label": "$(laon.principalAmount)",
  "calculatorForm.principalAmount.description": "Hvor meget ønsker I at låne?",
  "calculatorForm.principalAmount.placeholder": "0,00",
  "calculatorForm.loanPeriod.label": "$t(loanPeriod)",
  "calculatorForm.loanPeriod.description": "Hvor mange år ønsker i at låne pengene?",
  "calculatorForm.loanPeriod.placeholder": "Vælg løbetid",
  "calculatorForm.loanProduct.label": "$t(loanProduct)",
  "calculatorForm.loanProduct.placeholder": "Vælg produkttype",
  "calculatorForm.loanProduct.description": "Hvilket lån passer bedst til jeres behov?",
  "calculatorForm.amortizationProfile.label": "$t(amortizationProfile)",
  "calculatorForm.amortizationProfile.placeholder": "Vælg afdragsprofil",
  "calculatorForm.amortizationProfile.description": "Hvordan ønsker i at afdrage på lånet?",
  "calculatorForm.fixedInterestPeriod.label": "$t(fixedInterestPeriod)",
  "calculatorForm.fixedInterestPeriod.placeholder": "Vælg periode for rentebinding",
  "calculatorForm.fixedInterestPeriod.description": "Hvor mange år skal renten være fast?",
  "calculatorForm.rateFrequency.label": "$t(rateFrequency)",
  "calculatorForm.rateFrequency.placeholder": "Vælg rentefrekvens",
  "calculatorForm.rateFrequency.description": "Hvor ofte vil I betale renter?",
  "form.input.required": "Feltet er påkrævet",
  "calculatorForm.submit": "Beregn",
  "progress.percent": "Vis procenter",
  "progress.amount": "Vis beløb",
  "footer.terms": "Vilkår for brug",
  "footer.privacy": "Privatlivspolitik",
  "footer.data": "Personoplysninger og cookies",
  "footer.cookies": "Cookiesindstillinger",
  "navigation.home": "Forside",
  "navigation.contracts": "Aftaler",
  "navigation.guarantee": "Aftaler som garantstiller",
  "navigation.partnershipLiability": "Aftaler som interessent",
  "navigation.loans": "Støttede lån",
  "navigation.organization": "Organisation",
  "navigation.info": "Kontoindstillinger",
  "navigation.documents": "Dokumenter",
  "navigation.signature": "Underskriftsrum",
  "navigation.loggedInAs": "Du er logget ind som:",
  "navigation.calculator": "Lav låneberegning",
  "navigation.annualReports": "Årsopgørelser",
  "menu.profile": "Min profil",
  "burgerMenu.leasing": "Gå til leasing",
  "burgerMenu.logout": "Log ud",
  "loan.ContractLoan": "Aftalelån",
  "loan.ConstructionCredit": "Byggekreditter",
  "loan.BondLoan": "Obligationslån",
  "loan.SubsidizedLoan": "Støttede lån",
  "loan.Undefined": "$t(undefined)",
  "loan.Swap": "Swaps",
  "loan.originalLoanPeriod": "Oprindelig $t(loanPeriod)",
  "loan.paymentOverview": "Ydelsesoversigt",
  "loan.creditPostings": "Posteringsoversigt",
  "loan.contractId": "Aftale",
  "loan.loanProduct": "Produkttype",
  "loan.sustainableFramework": "Bæredygtig finansiering",
  "loan.projectName": "Projektnavn",
  "loan.amortizationProfile": "$t(amortizationProfile)",
  "loan.nextRateSetting": "Næste rentefastsættelse",
  "loan.rateFrequency": "Rentefrekvens",
  "loan.principalAmount": "Hovedstol",
  "loan.firstInterestDate": "Første rentebetaling",
  "loan.notionalAmount.credit": "Kredittræk",
  "loan.notionalAmount": "Restgæld",
  "loan.principalAmount.credit": "Kreditmaksimum",
  "loan.nonAccruedInterest.tooltip": "Fra seneste rentetilskrivning til sags dato",
  "loan.currency": "$t(currency)",
  "loan.agreementDate": "Aftaledato",
  "loan.remainingLoanPeriod": "Restløbetid",
  "loan.startDate": "Udbetalingsdato",
  "loan.payoutDate": "Udbetalingsdato",
  "loan.startDate.credit": "Start dato",
  "loan.maturityDate": "Udløbsdato",
  "loan.interestRate": "Rentesats",
  "loan.firstPayment": "Første ydelse",
  "loan.economicActivity": "Økonomisk aktivitet",
  "loan.interestConditionExpiryDate": "Udløb renteaftale",
  "loan.latestRateSetting": "Fastsat pr. {{ date, date }}",
  "loan.interestPaymentFrequency": "Rentefrekvens",
  "loan.redemptionValue.short": "Indfrielsesværdi (est.)*",
  "loan.redemptionValue.long": "Indfrielsesværdi (estimeret)",
  "loan.redemptionValue.tooltip": "Estimat baseret på gårsdagens renter. Afvigelser kan forekomme.",
  "loan.redemptionValue.description": "Indfrielsesværdien er et vejledende estimat baseret på gårsdagens renter og restgæld. Der kan derfor forekomme afvigelser. Kontakt din rådgiver for beregning af omkostningerne ved indfrielse af en specifik aftale.",
  "loan.spread": "KK tillæg",
  "loan.greenLoan": "greenLoan",
  "loan.loanCategory": "loanCategory",
  "loan.nextValueDate": "Næste termin",
  "loan.nextValueDate.credit": "Næste rentetilskrivning",
  "loan.marginRate": "Aktuel bidragssats",
  "loan.nonAccruedInterest": "Ikke tilskrevne renter",
  "loan.ratesAndPayments": "Renter og afdrag",
  "loan.disposableAmount": "Rådighedsbeløb",
  "loan.interestType": "Rentetype",
  "loan.interestType.Fixed": "Fast",
  "loan.interestType.Floating": "Variabelt",
  "loan.interestType.Undefined": "Ikke tilgængelig",
  "loan.bossInfoId": "BOSS-Info Nr.",
  "loan.bossInfoProjectName": "BOSS-Info Projekt",
  "loan.swaps": "swaps",
  "loan.swapRelatedContractId": "swapRelatedContractId",
  "loan.relation": "relation",
  "loan.legalName": "legalName",
  "loan.companyId": "companyId",
  "loan.asOfDate": "asOfDate",
  "loan.interestPaymentFrequency.M1": "Månedlig",
  "loan.interestPaymentFrequency.M2": "$t(unavailable)",
  "loan.interestPaymentFrequency.M3": "Kvartårlig",
  "loan.interestPaymentFrequency.M4": "$t(unavailable)",
  "loan.interestPaymentFrequency.M6": "Halvårlig",
  "loan.interestPaymentFrequency.M12": "Årlig",
  "loan.interestPaymentFrequency.UnDefined": "$t(unavailable)",
  "loan.borrower": "Låntager",
  "loan.noData.Owner": "I har ikke nogle {{loanType}}.",
  "loan.noData.Guarantee": "I har ikke stillet garanti for nogle {{loanType}}.",
  "loan.noData.PartnershipLiability": "I har ikke nogle {{loanType}} som interessent.",
  "loan.noData.BillReceiver": "Ingen lånedata",
  "loan.noData.Undefined": "Ingen lånedata",
  "loan.loanPurpose": "Låneformål",
  "loan.liabilityType": "Garantitype",
  "loan.liabilityAmount": "Garantibeløb",
  "loan.timeToMaturity": "Restløbetid",
  "loan.availableAmount": "Rådighedsbeløb",
  "loan.industryCode": "Økonomisk aktivitet",
  "liabilityType.ProRata": "Pro rata",
  "liabilityType.Solidarity": "Solidarisk",
  "liabilityType.Undefined": "$t(undefined)",
  "data.paymentTypeString": "Betalingstype",
  "data.notified": "Adviseret",
  "data.notified.short": "Adv.",
  "data.valueDate": "Valørdato",
  "data.repayment": "Afdrag",
  "data.interest": "Rente",
  "data.margin": "Bidrag",
  "data.marginRate": "Aktuel bidragssats",
  "data.payment": "Ydelse",
  "data.leasingPayment": "Leasingydelse",
  "data.notionalAmount": "Restgæld",
  "data.currentNotionalAmount": "Aktuel restgæld",
  "data.newNotionalAmount": "Ny restgæld",
  "data.accruedInterest": "Vedhængende rente",
  "data.redemptionRepayAmount": "Beløb til indfrielse",
  "data.compensationAmount": "Kompensationsbeløb",
  "data.calculatedCompensation": "Beregnet kompensation",
  "data.compensationAmount.tooltip": "Forskel mellem indfrielsesværdi og nominel restgæld",
  "data.paymentReduction": "Ydelsesreduktion",
  "data.paymentReduction.tooltip": "Reduktion i første ydelse efter afdrag",
  "data.PaymentReduction": "$t(data.paymentReduction)",
  "data.maturityReduction": "$t(changeMethod.ReducedTimeToMaturity)",
  "data.MaturityReduction": "$t(data.maturityReduction)",
  "data.EarlyTermination": "$t(data.maturityReduction)",
  "data.paymentAmount": "Afdragsbeløb",
  "data.paymentAmount.credit": "Beløb",
  "data.changeMethod": "Afdragsmetode",
  "data.creditAmount": "Kredittræk",
  "data.notionalAmountOnValueDate": "Restgæld før afdrag",
  "data.newMaturityDate": "Ny udløbsdato",
  "data.currency": "$t(currency)",
  "data.startDate": "Startdato",
  "data.newInterestAgreement.date": "Dato for ny renteaftale",
  "data.maturityDate": "Udløbsdato",
  "data.interestConditionExpiryDate": "Udløb af renteaftale",
  "data.notAvailable": "Ikke tilgængelig",
  "data.eventDueDateOnTerm": "Afdragsdato",
  "data.eventDueDateOutsideTerm": "Afdragsdato (uden for termin)",
  "data.individualCompensationAmount": "Individuelt fastsat kompensationsbeløb",
  "data.timeToMaturityReduction": "Løbetidsreduktion",
  "eventDescription.NewLoan": "Nyt lån",
  "eventDescription.ExtraRepayment": "Ekstraordinært afdrag",
  "eventDescription.FullRedemption": "Fuld indfrielse",
  "eventDescription.Redemption": "Indfrielse",
  "eventDescription.Conversion": "Konvertering",
  "eventDescription.NewInterestAgreement": "Ny renteaftale",
  "eventDescription.LoanPartlyRedemption": "$t(eventDescription.ExtraRepayment)",
  "eventDescription.LoanRedemption": "$t(eventDescription.FullRedemption)",
  "eventDescription.Fuld indfrielse": "$t(eventDescription.FullRedemption)",
  "eventDescription.Indfrielse": "$t(eventDescription.Redemption)",
  "eventDescription.Ekstraordinært afdrag": "$t(eventDescription.ExtraRepayment)",
  "standalone.newInterestAgreement": "Ny renteaftale",
  "standalone.determineAtTerm": "Fastsættes ved termin",
  "notified": "Adviseret",
  "notified.short": "Adv.",
  "no": "nej",
  "unavailable": "Ikke tilgængelig",
  "pdf": "PDF",
  "excel": "Excel",
  "seeStatus": "Se status",
  "goToSignature": "Gå til underskrift",
  "goToSignatureRoom": "Gå til underskriftsrum",
  "signaturePage.title": "Fortsæt til underskrift med MitID",
  "signaturePage.description": "Klik på knappen for at se og gennemgå dokumentet. Følg herefter vejledningen for at underskrive med MitID.",
  "signWithMitID": "Underskriv med MitID",
  "newLoan": "Nyt lån",
  "title": "Titel",
  "loan": "Aftale",
  "signature.deadline": "Frist for underskrift",
  "signature.status": "Status på underskrift",
  "documents.signature.description": "Her kan du få adgang til dokumenter, der kræver din underskrift. Du kan se oplysninger om dokumentet, tidsfrister og status på øvrige underskrivere.\nKlik på “Gå til underskrift” for at underskrive digitalt med MitID.",
  "documents.signature.information": "Oplysninger",
  "documents.signature.empty.title": "Ingen dokumenter tilgængelige",
  "documents.signature.empty.description": "Du kan ændre i filtreringen for at se allerede underskrevne dokumenter.",
  "document.signed.success.title": "Dokumentet er underskrevet",
  "document.signed.success.message": "Du kan tilgå dokumenter ved at ændre filtreringen til at inkludere underskrevne dokumenter",
  "document.signed.error.title": "Underskrift ikke registreret",
  "document.signed.error.message": "Der skete en fejl og din underskrift blev ikke registeret. Prøv igen eller kontakt din rådgiver.",
  "day_one": "dag",
  "day_other": "dage",
  "status": "Status",
  "signers": "Underskrivere",
  "guarantor_one": "garantistiller",
  "guarantor_other": "garantistillere",
  "stakeholder_one": "interessent",
  "stakeholder_other": "interessenter",
  "liability.guarantor.percentage": "Garantiprocent",
  "liability.guarantor.none": "Der er ingen garantistillere for denne aftale",
  "liability.interest.none": "Der er ingen interessenter for denne aftale",
  "contract.caseInformation.guaranteeType": "Garantitype",
  "contract.caseInformation.jointLiability": "Solidarisk garanti",
  "guaranteeRelation.GuarantorAlone": "Solidarisk",
  "guaranteeRelation.GuarantorProRata": "Pro rata",
  "guaranteeRelation.StakeHolderGuaranteeProRata": "Pro rata",
  "guaranteeRelation.GuarantorInSolidarity": "Solidarisk",
  "guaranteeRelation.StakeHolderGuarantee": "Interessent",
  "documents": "Dokumenter",
  "documents.active": "Til underskrift",
  "documents.notActive": "Underskrevne",
  "document.signed": "Underskrevet",
  "document.waiting": "Afventer",
  "documents.all": "Alle",
  "documents.filter": "Filtrer dokumenter",
  "documents.more": "Vis flere dokumenter",
  "documents.less": "Vis færre dokumenter",
  "documentType.AllongeToPromissoryNote": "Tillæg til låneaftale",
  "documentType.LoanDocument": "Lånedokument",
  "documentType.PowerOfAttorney": "Fuldmagt",
  "owner.contracts": "Vores aftaler",
  "guarantee.contracts": "Aftaler som garantistiller",
  "byLaws": "Vedtægter",
  "nextReminder": "Næste påmindelse",
  "verifyInfo.title": "Verificer oplysninger",
  "verifyInfo.subtitle": "Verificer, at de nuværede oplysninger er korrekte og tilføj eventuelt manglende oplysninger.",
  "verifyInfo.infobox": "Ved tryk på ‘Gem og fortsæt’ giver du samtidig samtykke til, at vi kan behandle og opbevare dine oplysninger som beskrevet i vores politik for Personoplysninger og cookies.",
  "verifyInfo.name": "For- og efternavn",
  "verifyInfo.company": "Virksomhed",
  "verifyInfo.email": "E-mail",
  "saveAndContinue": "Gem og fortsæt",
  "case.number.short": "Sagsnr.",
  "logOut": "Log ud",
  "menu": "Menu",
  "pdf.download.error.title": "Fejl ved hentning af PDF",
  "pdf.download.error.message": "Der opstod en fejl under hentning af PDF. Prøv igen eller kontakt support på +45 XX XX XX XX",
  "notRelevant": "Ikke relevant",
  "errorPage.title": "Hov! Vi kunne ikke finde siden",
  "errorPage.body.204": "Fejl 204. Hov! Vi kan desværre ikke finde den side, du leder efter. Kontrollér din internetforbindelse, og prøv at genindlæse siden (tast F5).",
  "errorPage.body.403": "Fejl 403. Hov! Vi kan desværre ikke vise dig den side eller det indhold, du leder efter. Det kan skyldes, at adgangen er begrænset. Prøv at logge ind igen.",
  "errorPage.body.404": "Fejl 404. Hov! Vi kan desværre ikke finde den side, du leder efter. Det kan skyldes, at siden ikke findes, eller at vi har flyttet den. Der kan også være slåfejl i linket eller forstyrrelser i vores drift. Prøv at gå tilbage til forsiden, eller søg efter siden igen.",
  "errorPage.body.500": "Fejl 500. Hov! Vi kan desværre ikke finde den side, du leder efter. Det kan skyldes problemer med serveren, en fejl i hjemmesidens kode eller midlertidige tekniske udfordringer. Prøv at genindlæse siden (tast F5) eller vend tilbage senere. Hvis problemet fortsætter, kan du kontakte vores support.",
  "errorPage.contactSupport": "Kontakt support",
  "organizationPage.title": "Kundeoplysninger",
  "organizationPage.description": "Her kan du se og administrere dine kundeoplysninger.",
  "organizationPage.tabs.information": "Oplysninger",
  "organizationPage.tabs.usersAndRoles": "Brugere og roller",
  "organizationPage.guarantors.description": "Her kan I se en liste over de kommuner/regioner, der stiller garanti for jeres aftaler.",
  "organizationPage.stakeholders.description": "Her kan I se en liste over de interessenter, der hæfter for jeres aftaler.",
  "organizationPage.information.description": "Her kan I se oplysninger om jeres virksomhed. Det er jeres ansvar, at informationerne er retvisende. Såfremt nogle af oplysningerne skal rettes, bedes I kontakte jeres rådgiver.",
  "organizationPage.companyInfo.title": "Virksomhedsoplysninger",
  "organizationPage.companyInfo.name": "Virksomhedsnavn",
  "organizationPage.companyInfo.noData": "Ingen virksomhedsoplysninger tilgængelige",
  "organizationPage.companyInfo.contactInfo": "$t(contactInfo)",
  "organizationPage.companyInfo.primaryContact": "Primær kontaktperson",
  "organizationPage.companyInfo.cvr": "CVR-nummer",
  "organizationPage.companyInfo.companyNumber": "Kundenummer",
  "organizationPage.companyInfo.address": "$t(address)",
  "organizationPage.companyInfo.phone": "$t(phone)",
  "organizationPage.companyInfo.email": "$t(email)",
  "organizationPage.companyInfo.contactName": "$t(name)",
  "organizationPage.companyInfo.contactTitle": "Stillingsbetegnelse",
  "organizationPage.companyInfo.contactEmail": "$t(email)",
  "organizationPage.companyInfo.contactPhone": "$t(phone)",
  "organizationPage.companyInfo.noContact": "Ingen kontaktperson tilgængelig",
  "organizationPage.companyInfo.contactName.placeholder": "[Navn Navnesen]",
  "organizationPage.companyInfo.contactEmpty.title": "Der er ingen primær kontaktperson",
  "organizationPage.companyInfo.contactEmpty.description": "Kontakt venligst jeres rådgiver, for at udpege primær kontaktperson.",
  "organizationPage.companyInfo.typeOfLiability": "Ansvarsform",
  "organizationPage.bylaws.title": "Vedtægter",
  "organizationPage.bylaws.description": "Her kan I se de seneste vedtægter, som er oplyst som gældende for jeres virksomhed.",
  "organizationPage.bylaws.empty.title": "Der er ingen vedtægter tilgængelige",
  "organizationPage.bylaws.empty.description": "Fremsend venligst de seneste vedtægter til jeres rådgiver.",
  "organizationPage.usersAndRoles.description": "Her kan I se en oversigt over brugerne i jeres organisation og deres tilknyttede roller. For at ændre roller og rettigheder, skal du kontakte jeres administrator, som kan gøre dette via Signaturgruppens rettighedsmodulet.",
  "profilePage.title": "Mine oplysninger",
  "profilePage.widget.title": "Brugeroplysninger",
  "profilePage.editEmail": "Rediger e-mail",
  "profilePage.email.title": "Rediger e-mail",
  "profilePage.email.subTitle": "Alle ændringer vil slå igennem på tværs af din organisation",
  "profilePage.email.placeholder": "mail@mail.dk",
  "profilePage.email.invalid": "Den indtastede e-mail er ikke gyldig",
  "profilePage.email.required": "E-mail er påkrævet",
  "profilePage.email.updateSuccess": "E-mail er opdateret",
  "profilePage.email.updateSuccess.message": "E-mail er opdateret til {{email}}",
  "profilePage.email.updateError": "E-mail kunne ikke opdateres",
  "profilePage.signaturGruppen": "* Administreres hos Signaturgruppen",
  "calendar.latestBankDay": "Seneste bankdag",
  "save": "Gem",
  "cancel": "Annuller",
  "annualReportsPage.title": "Årsopgørelser",
  "annualReportsPage.subTitle": "Her kan du se dine årsopgørelser for de seneste 5 år. Klik på titlen for at åbne dokumentet i din browser, hvorfra du også kan downloade dokumentet.",
  "annualReportsPage.empty.title": "Der er ingen dokumenter tilgængelige",
  "annualReportsPage.empty.description": "Der er i øjeblikket ingen dokumenter tilgængelige. Det kan skyldes, at de endnu ikke er uploadet, eller at adgangen er begrænset.",
  "date": "Dato",
  "fileSize": "Filstørrelse",
  "created": "Oprettet",
  "search.placeholder": "Søg aftale",
  "search.unsupportedLoanType": "Søg aftale",
  "search.expiredLoan": "Udløbet",
  "search.clear": "Ryd",
  "search.latest": "Seneste resultater",
  "search.noResults": "Ingen søgeresultater fundet",
  "mitId": "MitID",
  "mitId.MitIdPrivat": "Privat",
  "mitId.MitIdErhverv": "Erhverv"
}
